/** Friendly labels for diner profileExtend (admin consult views). */

const VALUE_LABELS = {
  // demographic
  woman: "Woman",
  man: "Man",
  non_binary: "Non-binary",
  prefer_not: "Prefer not to say",
  "18_24": "18–24",
  "25_34": "25–34",
  "35_44": "35–44",
  "45_54": "45–54",
  "55_plus": "55+",
  solo: "Just me",
  couple: "With partner",
  family: "With family",
  shared: "With friends / flatmates",
  student: "Student life",
  employed: "Working days",
  self_employed: "Own business",
  other: "Something else",
  fr: "Français",
  en: "English",
  ar: "العربية",
  es: "Español",
  de: "Deutsch",
  // behavior
  weekly: "Almost every week",
  monthly: "A few times a month",
  occasional: "Now and then",
  rare: "For special days",
  lunch: "Lunch break",
  dinner: "Dinner out",
  brunch: "Brunch",
  date: "Date night",
  business: "Work meal",
  celebration: "Celebrations",
  early: "Early bird",
  midday: "Midday",
  evening: "Evening glow",
  late: "Late & cozy",
  dine_in: "Stay & enjoy",
  takeaway: "Take it home",
  both: "A bit of both",
  mild: "Gentle",
  medium: "Nice kick",
  hot: "Bring the heat",
  extra: "Fire lover",
  value: "Smart & simple",
  mid: "Comfortable",
  premium: "Treat myself",
  vegetarian: "Vegetarian",
  vegan: "Vegan",
  halal: "Halal",
  gluten_free: "Gluten-free",
  lactose_free: "Lactose-free",
  none: "Eats everything",
  // psychological
  comfort: "Cozy comfort",
  indulgent: "A little treat",
  healthy: "Feel-good plate",
  adventurous: "Surprise me",
  social: "Share & smile",
  quick: "Quick & tasty",
  local: "Local flavors",
  sustainable: "Kind to the planet",
  quality: "Great ingredients",
  speed: "No long wait",
  ambiance: "Beautiful vibe",
  service: "Warm welcome",
  intimate: "Quiet & intimate",
  lively: "Lively & fun",
  quiet: "Calm corner",
  flexible: "Whatever fits",
  comfort_zone: "Favorites",
  balanced: "Mix of both",
  explorer: "Always curious",
  loyal: "Comes back often",
  rotating: "Likes to rotate",
  new_spots: "Hunts new places",
};

export function labelProfileValue(value) {
  if (value == null || value === "") return "";
  const key = String(value);
  return VALUE_LABELS[key] || key.replace(/_/g, " ");
}

export function formatProfileChips(value) {
  if (Array.isArray(value)) {
    return value.map(labelProfileValue).filter(Boolean);
  }
  const single = labelProfileValue(value);
  return single ? [single] : [];
}

export function buildTasteSections(profileExtend) {
  if (!profileExtend || typeof profileExtend !== "object") return [];

  const sections = [
    {
      key: "behavior",
      title: "How they dine",
      hint: "Habits at the table",
      rows: [
        { label: "How often", value: profileExtend.behavior?.visitFrequency },
        { label: "Best moments", value: profileExtend.behavior?.diningOccasion },
        { label: "Preferred times", value: profileExtend.behavior?.preferredTimes },
        { label: "Order style", value: profileExtend.behavior?.orderStyle },
        { label: "Spice comfort", value: profileExtend.behavior?.spiceLevel },
        { label: "Usual spend", value: profileExtend.behavior?.budget },
        { label: "Plate preferences", value: profileExtend.behavior?.dietary },
      ],
    },
    {
      key: "demographic",
      title: "A bit about them",
      hint: "Simple welcome details",
      rows: [
        { label: "Identity", value: profileExtend.demographic?.gender },
        { label: "Age group", value: profileExtend.demographic?.ageRange },
        { label: "Usually dine with", value: profileExtend.demographic?.household },
        { label: "Everyday life", value: profileExtend.demographic?.occupation },
        { label: "Language", value: profileExtend.demographic?.language },
      ],
    },
    {
      key: "psychological",
      title: "Food mood",
      hint: "Vibe & preferences",
      rows: [
        { label: "When they sit down", value: profileExtend.psychological?.foodMoods },
        { label: "What makes a place special", value: profileExtend.psychological?.values },
        { label: "Atmosphere", value: profileExtend.psychological?.socialStyle },
        { label: "On the menu", value: profileExtend.psychological?.exploration },
        { label: "With restaurants they like", value: profileExtend.psychological?.loyalty },
      ],
    },
  ];

  return sections
    .map((section) => ({
      ...section,
      rows: section.rows
        .map((row) => ({
          ...row,
          chips: formatProfileChips(row.value),
        }))
        .filter((row) => row.chips.length > 0),
    }))
    .filter((section) => section.rows.length > 0);
}
